var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.701,
    height: 21.661,
    viewBox: "0 0 21.701 21.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M481.888,278.414h4.5v14.469h-4.5Zm2.252-7.192a2.608,2.608,0,1,1-2.609,2.607,2.608,2.608,0,0,1,2.609-2.607",
    transform: "translate(-481.531 -271.222)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M503.843,291.434h4.311v1.978h.062a4.724,4.724,0,0,1,4.254-2.337c4.554,0,5.4,3,5.4,6.893V305.9h-4.5v-7.036c0-1.678-.029-3.837-2.337-3.837-2.34,0-2.7,1.829-2.7,3.716V305.9h-4.492Z",
    transform: "translate(-496.164 -284.242)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSvg);
export default __webpack_public_path__ + "static/media/linkedin-svg.1a48cbe7a80048fd1687b24b88b44641.svg";
export { ForwardRef as ReactComponent };